import page from './Card.vue';
export default page;


// WEBPACK FOOTER //
// ./src/pages/event/card/index.js